import React, { useEffect, useState } from "react";
import "./AdminPopupImg.css";

import NewImg from "../../images/adminNewImg.svg";
import Close from "../../images/adminNewImgClose.svg";

function AdminPopupImg(props) {
  const [inputs, setInputs] = useState(false);
  useEffect(() => {
    console.log(props.formValues);
  });
  function handleImageUploadFirst(e) {
    const file = e.target.files[0]; // Получаем первый загруженный файл
    if (file) {; // Создаем временный URL для файла
      props.setFormValues({
        ...props.formValues,
        firstImage: file, // Сохраняем URL в state
      });
    }
  }

  function handleImageUploadTwo(e) {
    const file = e.target.files[0]; // Получаем первый загруженный файл
    if (file) {
      props.setFormValues({
        ...props.formValues,
        TwoImage: file, // Сохраняем URL в state
      });
    }
  }

  return (
    <div className="AdminPopupImg">
      <div className="adminpopupimg__popup">
        <img
          onClick={() => {
            props.setAdminImg(false);

            props.setFormValues({
              ...props.formValues,
              firstImage: "",
              TwoImage: "",
            });
          }}
          alt="icon"
          className="adminpopupimg__popup__close"
          src={Close}
        />
        <label className="adminpopupimg__popup__label">
          <img
            src={NewImg}
            alt="icon"
            className="adminpopupimg__popup__label__img"
          />
          <p className="adminpopupimg__popup__label__title">
            Загрузить новое изображение
          </p>
          {props.formValues.firstImage && (
            <img
              src={URL.createObjectURL(props.formValues.firstImage)}
              alt="Выбранное"
              className="adminpopupimg__popup__label__imgv"
            />
          )}
          <input
            type="file"
            className="adminpopupimg__popup__label__input"
            onChange={handleImageUploadFirst}
          />
        </label>
        <div className="adminpopupimg__popup__btns">
          <button
            onClick={() => {
              props.setAdminImg(false);
            }}
            className="adminpopupimg__popup__btns__btn"
          >
            Объединить
          </button>
          <div className="adminpopupimg__popup__btns__btns">
            <button
              onClick={() => {
                setInputs(false);
                props.setFormValues({
                  ...props.formValues,
                  TwoImage: "", // Сохраняем URL в state
                });
              }}
              className={`adminpopupimg__popup__btns__btns__btn ${
                !inputs && "active"
              }`}
            >
              1
            </button>
            <button
              onClick={() => {
                setInputs(true);
              }}
              className={`adminpopupimg__popup__btns__btns__btn ${
                inputs && "active"
              }`}
            >
              2
            </button>
          </div>
        </div>

        <div className={`adminpopupimg__popup__label ${!inputs && "noactive"}`}>
          <img
            src={NewImg}
            alt="icon"
            className="adminpopupimg__popup__label__img"
          />
          <p className="adminpopupimg__popup__label__title">
            Загрузить новое изображение
          </p>
          {props.formValues.TwoImage && (
            <img
              src={URL.createObjectURL(props.formValues.TwoImage)}
              alt="Выбранное"
              className="adminpopupimg__popup__label__imgv"
            />
          )}
          <input
            onChange={handleImageUploadTwo}
            type="file"
            className="adminpopupimg__popup__label__input"
          />
        </div>
      </div>
    </div>
  );
}

export default AdminPopupImg;
